<template>
  <div>
    <unit-title title="生产企业" />
    <van-image class="company-image" fit="cover" :src="companyData.pic | firstImg" />
    <div class="name">
      {{ companyData.name }}
    </div>
    <div class="profile">
      {{ companyData.profile }}
    </div>
    <div>
      <div class="base-info">
        <div class="caption">
          企业基本信息：
        </div>
        <div class="info-list">
          <div class="info-list-item">
            <span class="label">企业名称:</span>
            <span class="content">{{ companyData.name }}</span>
          </div>
          <div class="info-list-item">
            <span class="label">法人:</span>
            <span class="content">{{ companyData.legalPerson }}</span>
          </div>
          <div class="info-list-item">
            <span class="label">法人电话:</span>
            <span class="content">{{ companyData.mobile }}</span>
          </div>
          <div class="info-list-item">
            <span class="label">客服电话:</span>
            <span class="content">{{ companyData.serviceTel }}</span>
          </div>
          <div class="info-list-item">
            <span class="label">营业执照代码:</span>
            <span class="content">{{ companyData.uscCode }}</span>
          </div>
        </div>
        <div class="caption">
          企业资质：
        </div>
        <div class="info-list">
          <div v-if="companyData.pic" class="info-list-item">
            <span class="label">经营执照:</span>
            <van-tag type="primary" class="content tag" @click="displayImages(companyData.uscPic)">
              查看
            </van-tag>
          </div>
          <div v-if="companyData.pic" class="info-list-item">
            <span class="label">营业许可证:</span>
            <van-tag type="primary" class="content tag" @click="displayImages(companyData.businessPic)">
              查看
            </van-tag>
          </div>
          <div v-if="companyData.pic" class="info-list-item">
            <span class="label">生产许可证:</span>
            <van-tag type="primary" class="content tag" @click="displayImages(companyData.productPic)">
              查看
            </van-tag>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firstImg } from '@/filter'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import { ImagePreview } from 'vant'
export default {
  name: 'CompanyData',
  components: { UnitTitle },
  filters: {
    firstImg
  },
  props: {
    companyData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    displayImages(pic) {
      // console.log(pic)
      let picUrlArr = []
      if (pic && pic.length) {
        picUrlArr = pic.map(item => item.url)
      }
      ImagePreview({
        images: picUrlArr,
        closeable: true
      })
    }
  }
}
</script>

<style lang='less' scoped>
.company-image {
  width: 100%;
  height: 200px;
}
.name  {
  font-size: 14px;
  font-weight: bold;
  color: #323332;
  margin-top: 10px;
}
.profile {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #323332;
  text-indent: 2em;
  padding: 10px 0 0;
}
.base-info {
  .caption {
    margin-top: 16px;
    padding-top: 20px;
    border-top: 1px solid #d6d6d6;
  }
  .info-list {
    .info-list-item {
      margin-top: 20px;
      .label,
      .content {
        display: inline-block;
      }
      .label {
        text-align: right;
        width: 110px;
      }
      .content {
        margin-left: 10px;
        &.tag {
          padding: 2px 1em;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
